<div class="manage-properties-container bg-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-8 sm:py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 class="text-3xl sm:text-5xl font-bold mb-2">Manage Properties</h1>
          <p class="text-base sm:text-xl text-blue-100">View and manage all property listings</p>
        </div>
        <button 
          (click)="goBack()"
          class="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition font-medium flex items-center gap-2 text-sm sm:text-base">
          <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
          Back
        </button>
      </div>
    </div>
  </section>

  <div class="max-w-7xl mx-auto py-6 sm:py-12 px-4 sm:px-6 lg:px-8">
    <!-- Statistics Cards -->
    <div *ngIf="!loading()" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
      <!-- Total Properties -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-blue-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Total Properties</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ totalPropertiesCount }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Published -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-green-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Published</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ publishedCount }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Draft -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-yellow-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Draft</p>
            <p class="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2">{{ draftCount }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Total Value -->
      <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 border-l-4 border-purple-500 hover:shadow-lg transition">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600 uppercase">Total Value</p>
            <p class="text-xl sm:text-2xl font-bold text-gray-900 mt-1 sm:mt-2">{{ propertyService.formatPrice(totalValue, 'USD') }}</p>
          </div>
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="error()" class="bg-red-50 border-l-4 border-red-500 text-red-700 px-4 py-3 rounded mb-6 flex items-start gap-3">
      <svg class="w-5 h-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
      </svg>
      <div class="flex-1">{{ error() }}</div>
      <button (click)="error.set('')" class="text-red-700 hover:text-red-900">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>

    <!-- Top Action Bar -->
    <div class="bg-white rounded-lg shadow-md p-4 sm:p-6 mb-6 space-y-4">
      <!-- Search and View Controls -->
      <div class="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
        <div class="flex-1">
          <div class="relative">
            <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            <input 
              type="text"
              [(ngModel)]="searchQuery"
              (ngModelChange)="currentPage.set(1)"
              placeholder="Search by title, city, state, or description..."
              class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-immovea-navy focus:border-transparent bg-gray-50">
          </div>
        </div>
        <div class="flex gap-2">
          <button 
            (click)="addNewListing()"
            class="flex-1 sm:flex-none bg-immovea-navy text-white px-4 sm:px-6 py-3 rounded-lg hover:bg-blue-900 transition font-semibold flex items-center justify-center gap-2 whitespace-nowrap">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            <span class="hidden sm:inline">Add Property</span>
            <span class="sm:hidden">Add</span>
          </button>
        </div>
      </div>

      <!-- Advanced Filters -->
      <div class="border-t pt-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
            </svg>
            Filters
          </h3>
          <button
            (click)="resetFilters()"
            class="text-xs text-gray-600 hover:text-immovea-navy font-medium flex items-center gap-1">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            Reset All
          </button>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <!-- Status Filter -->
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Status</label>
            <select 
              [(ngModel)]="statusFilter"
              (ngModelChange)="currentPage.set(1)"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-immovea-navy focus:border-transparent bg-white text-sm">
              <option value="all">All Properties</option>
              <option value="published">Published Only</option>
              <option value="draft">Drafts Only</option>
            </select>
          </div>

          <!-- Property Type Filter -->
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Property Type</label>
            <select 
              [(ngModel)]="propertyTypeFilter"
              (ngModelChange)="currentPage.set(1)"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-immovea-navy focus:border-transparent bg-white text-sm">
              <option value="all">All Types</option>
              <option *ngFor="let type of uniquePropertyTypes" [value]="type">{{ type }}</option>
            </select>
          </div>

          <!-- Price Range Filter -->
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Price Range</label>
            <select 
              [(ngModel)]="priceRangeFilter"
              (ngModelChange)="currentPage.set(1)"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-immovea-navy focus:border-transparent bg-white text-sm">
              <option value="all">All Prices</option>
              <option value="0-100000">Under $100k</option>
              <option value="100000-250000">$100k - $250k</option>
              <option value="250000-500000">$250k - $500k</option>
              <option value="500000-1000000">$500k - $1M</option>
              <option value="1000000-99999999">Over $1M</option>
            </select>
          </div>

          <!-- Location Filter -->
          <div>
            <label class="block text-xs font-medium text-gray-600 mb-1">Location</label>
            <select 
              [(ngModel)]="locationFilter"
              (ngModelChange)="currentPage.set(1)"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-immovea-navy focus:border-transparent bg-white text-sm">
              <option value="all">All Locations</option>
              <option *ngFor="let location of uniqueLocations" [value]="location">{{ location }}</option>
            </select>
          </div>
        </div>

        <!-- Results Summary -->
        <div class="mt-3 text-sm text-gray-600">
          Showing <span class="font-semibold text-gray-900">{{ (currentPage() - 1) * itemsPerPage + 1 }}</span> 
          to <span class="font-semibold text-gray-900">{{ Math.min(currentPage() * itemsPerPage, filteredProperties.length) }}</span> 
          of <span class="font-semibold text-gray-900">{{ filteredProperties.length }}</span> properties
        </div>
      </div>

      <!-- Bulk Actions Bar -->
      <div *ngIf="selectedCount > 0" class="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
            {{ selectedCount }}
          </div>
          <span class="text-gray-700 font-medium">{{ selectedCount }} item{{ selectedCount > 1 ? 's' : '' }} selected</span>
        </div>
        <div class="flex flex-wrap gap-2">
          <button
            (click)="bulkPublish()"
            [disabled]="bulkActionInProgress()"
            class="flex-1 sm:flex-none px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Publish
          </button>
          <button
            (click)="bulkUnpublish()"
            [disabled]="bulkActionInProgress()"
            class="flex-1 sm:flex-none px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
            Unpublish
          </button>
          <button
            (click)="bulkDelete()"
            [disabled]="bulkActionInProgress()"
            class="flex-1 sm:flex-none px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
            Delete
          </button>
          <button
            (click)="clearSelection()"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium">
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading()" class="space-y-4">
      <div *ngFor="let i of [1,2,3,4]" class="bg-white rounded-lg overflow-hidden shadow-md animate-pulse">
        <div class="flex gap-4 p-6">
          <div class="w-20 h-20 bg-gray-200 rounded-lg flex-shrink-0"></div>
          <div class="flex-1 space-y-3">
            <div class="h-6 bg-gray-200 rounded w-1/3"></div>
            <div class="h-4 bg-gray-200 rounded w-1/2"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading() && filteredProperties.length === 0" class="bg-white rounded-lg shadow-md py-20 px-8">
      <div class="max-w-md mx-auto text-center">
        <!-- Icon -->
        <div class="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center">
          <svg class="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
          </svg>
        </div>
        
        <!-- Message -->
        <h3 class="text-2xl font-bold text-gray-900 mb-3">No Properties Found</h3>
        <p class="text-gray-600 mb-6">
          <span *ngIf="searchQuery()">No properties match your search criteria. Try adjusting your filters.</span>
          <span *ngIf="!searchQuery()">Get started by creating your first property listing. It only takes a few minutes!</span>
        </p>
        
        <!-- Action Button -->
        <button
          *ngIf="!searchQuery()"
          (click)="addNewListing()"
          class="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-immovea-navy to-blue-700 text-white rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Create First Listing
        </button>
      </div>
    </div>

    <!-- Properties List -->
    <div *ngIf="!loading() && filteredProperties.length > 0" class="space-y-4">
      <!-- Select All Bar -->
      <div class="bg-white rounded-lg shadow-md p-4">
        <div class="flex items-center justify-between gap-4">
          <label class="flex items-center gap-3 cursor-pointer group">
            <input 
              type="checkbox" 
              [checked]="isAllSelected()"
              (change)="toggleSelectAll()"
              class="w-5 h-5 rounded border-2 border-gray-300 text-immovea-navy focus:ring-2 focus:ring-immovea-navy focus:ring-offset-0 cursor-pointer">
            <span class="text-sm font-semibold text-gray-700 group-hover:text-gray-900">Select All</span>
          </label>
          <div class="text-sm text-gray-600">
            <span class="font-semibold text-gray-900">{{ filteredProperties.length }}</span> properties
          </div>
        </div>
      </div>

      <!-- Properties Cards -->
      <div class="space-y-4">
        <div *ngFor="let property of paginatedProperties" 
             class="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border-l-4"
             [class.border-green-500]="property.is_published"
             [class.border-gray-400]="!property.is_published">
          <div class="p-4 sm:p-6">
            <div class="flex items-start gap-4">
              <!-- Checkbox -->
              <div class="flex items-center pt-1">
                <input 
                  type="checkbox" 
                  [checked]="isSelected(property.id)"
                  (change)="toggleSelection(property.id)"
                  class="w-5 h-5 rounded border-2 border-gray-300 text-immovea-navy focus:ring-2 focus:ring-immovea-navy focus:ring-offset-0 cursor-pointer">
              </div>

              <!-- Image -->
              <div class="w-20 h-20 sm:w-28 sm:h-28 bg-gray-200 rounded-xl overflow-hidden flex-shrink-0">
                <img 
                  *ngIf="propertyService.getPrimaryImage(property); let img"
                  [src]="propertyService.getImageUrlFromCache(img.storage_path)"
                  alt="{{ property.title }}"
                  class="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  onerror="this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22%3E%3Crect fill=%22%23e5e7eb%22 width=%22100%22 height=%22100%22/%3E%3Ctext x=%2250%22 y=%2250%22 font-size=%2214%22 fill=%22%23999%22 text-anchor=%22middle%22 dy=%22.3em%22%3ENo Image%3C/text%3E%3C/svg%3E'">
                <div *ngIf="!propertyService.getPrimaryImage(property)" class="w-full h-full flex items-center justify-center">
                  <svg class="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd"></path>
                  </svg>
                </div>
              </div>

              <!-- Content -->
              <div class="flex-1 min-w-0">
                <div class="flex flex-col gap-3">
                  <!-- Title and Status -->
                  <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
                    <div class="flex-1 min-w-0">
                      <h3 class="font-bold text-gray-900 text-lg sm:text-xl truncate">{{ property.title }}</h3>
                      <div class="flex flex-wrap items-center gap-2 mt-1.5 text-sm text-gray-600">
                        <span class="flex items-center gap-1">
                          <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                          </svg>
                          {{ property.city }}<span *ngIf="property.state">, {{ property.state }}</span>
                        </span>
                        <span class="text-gray-400">•</span>
                        <span class="font-medium capitalize">{{ property.property_type }}</span>
                      </div>
                    </div>
                    <button 
                      (click)="togglePublish(property)"
                      [class.bg-green-100]="property.is_published"
                      [class.text-green-800]="property.is_published"
                      [class.bg-gray-100]="!property.is_published"
                      [class.text-gray-800]="!property.is_published"
                      class="px-3 py-1.5 rounded-full text-xs font-semibold transition-colors cursor-pointer hover:opacity-80 flex items-center gap-1.5 whitespace-nowrap">
                      <span class="w-2 h-2 rounded-full"
                            [class.bg-green-500]="property.is_published"
                            [class.bg-gray-400]="!property.is_published"></span>
                      {{ property.is_published ? 'Published' : 'Draft' }}
                    </button>
                  </div>

                  <!-- Price -->
                  <div class="font-bold text-immovea-navy text-xl sm:text-2xl">
                    {{ propertyService.formatPrice(property.price, property.currency) }}
                  </div>

                  <!-- Property Details -->
                  <div class="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                    <div *ngIf="property.bedrooms" class="flex items-center gap-1.5">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                      </svg>
                      <span class="font-medium">{{ property.bedrooms }}</span> Bed
                    </div>
                    <div *ngIf="property.bathrooms" class="flex items-center gap-1.5">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"></path>
                      </svg>
                      <span class="font-medium">{{ property.bathrooms }}</span> Bath
                    </div>
                    <div *ngIf="property.area" class="flex items-center gap-1.5">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"></path>
                      </svg>
                      <span class="font-medium">{{ property.area }}</span> m²
                    </div>
                    <div *ngIf="property.listing_type" class="flex items-center gap-1.5">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                      </svg>
                      <span class="capitalize">{{ property.listing_type }}</span>
                    </div>
                  </div>

                  <!-- Actions -->
                  <div class="flex flex-wrap items-center gap-2 pt-2 border-t border-gray-100">
                    <button
                      (click)="editProperty(property.id)"
                      class="flex-1 sm:flex-none bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition font-medium text-sm flex items-center justify-center gap-2">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                      </svg>
                      Edit
                    </button>
                    <a
                      [routerLink]="['/property', property.id]"
                      target="_blank"
                      class="flex-1 sm:flex-none bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition font-medium text-sm flex items-center justify-center gap-2">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                      </svg>
                      View
                    </a>
                    <button
                      (click)="deleteProperty(property.id)"
                      [disabled]="deleting() === property.id"
                      class="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                      </svg>
                      {{ deleting() === property.id ? 'Deleting...' : 'Delete' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination Controls -->
      <div *ngIf="totalPages > 1" class="bg-white rounded-lg shadow-md p-4 mt-4">
        <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
          <!-- Page Info -->
          <div class="text-sm text-gray-600">
            Page <span class="font-semibold text-gray-900">{{ currentPage() }}</span> of <span class="font-semibold text-gray-900">{{ totalPages }}</span>
          </div>

          <!-- Page Numbers -->
          <div class="flex items-center gap-1 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pb-2 sm:pb-0">
            <!-- Previous Button -->
            <button
              (click)="previousPage()"
              [disabled]="currentPage() === 1"
              class="px-3 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center gap-1 text-sm font-medium whitespace-nowrap">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
              <span class="hidden sm:inline">Previous</span>
            </button>

            <!-- Page Numbers -->
            <div class="flex items-center gap-1">
              <button
                *ngFor="let page of pageNumbers"
                (click)="goToPage(page)"
                [disabled]="page === '...'"
                [class.bg-immovea-navy]="page === currentPage()"
                [class.text-white]="page === currentPage()"
                [class.border-immovea-navy]="page === currentPage()"
                [class.hover:bg-gray-50]="page !== currentPage() && page !== '...'"
                class="min-w-[40px] px-3 py-2 rounded-lg border border-gray-300 text-gray-700 transition text-sm font-medium disabled:cursor-default disabled:hover:bg-transparent">
                {{ page }}
              </button>
            </div>

            <!-- Next Button -->
            <button
              (click)="nextPage()"
              [disabled]="currentPage() === totalPages"
              class="px-3 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center gap-1 text-sm font-medium whitespace-nowrap">
              <span class="hidden sm:inline">Next</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>
          </div>

          <!-- Items per page info -->
          <div class="text-sm text-gray-600">
            <span class="font-semibold text-gray-900">{{ itemsPerPage }}</span> per page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
